export default {
  namespaced: true,
  state: {
    user: null,
  },
  getters: {
    user: (state) => state.user,
    isLoggedIn: (state) => !!state.user,
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
  },
  actions: {
    async setUser({ commit, dispatch }, user) {
      commit("setUser", user);
      if (user) {
        await dispatch("partner/fetchAccounts", user, { root: true });
        if (window.HelpCrunch) {
          var update = {
            source: "whitelabel-dashboard",
            email: user.email || "",
            phone: user.phoneNumber || "",
            name: user.displayName || "",
            user_id: user.uid,
          };
          window.HelpCrunch("updateUser", update);
        }
      } else {
        commit("setUser", null);
        dispatch("partner/clearAccounts", null, { root: true });
        // window.HelpCrunch("updateUser", {
        //   email: "",
        //   phone: "",
        //   name: "",
        //   user_id: "",
        // });
      }
    },
  },
};
